// extracted by mini-css-extract-plugin
export default {"your_rd":"EG","title":"FG","subtitle":"GG","rd_bio_wrapper":"HG","rd_text_mobile":"IG","rd_bio":"JG","img":"KG","rd_info":"LG","rd_name":"MG","rd_stat":"NG","rd_text":"OG","btn_mobile":"PG"};
    if(module.hot) {
      // 1737143662011
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  